/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Search_ButtonInputs */



/**
* | output |
* | --- |
* | "Search" |
*
* @param {Explorer_Search_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_search_button = /** @type {((inputs?: Explorer_Search_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Search_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Search")
	if (locale === "de") return /** @type {LocalizedString} */ ("Search")
	if (locale === "it") return /** @type {LocalizedString} */ ("Search")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Search")
	if (locale === "es") return /** @type {LocalizedString} */ ("Search")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Search")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Search")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Search")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Search")
	return /** @type {LocalizedString} */ ("Search")
});